// URL search-param schema for /cms/products. Used by the route's
// `validateSearch` and consumed via `useSearch` in the list page.

export type CmsProductsSearch = {
  title?: string;
  contentCategory?: string;
  page?: number;
};

export const validateCmsProductsSearch = (
  input: Record<string, unknown>
): CmsProductsSearch => {
  const result: CmsProductsSearch = {};
  if (typeof input.title === 'string' && input.title.length > 0) {
    result.title = input.title;
  }
  if (
    typeof input.contentCategory === 'string' &&
    input.contentCategory.length > 0
  ) {
    result.contentCategory = input.contentCategory;
  }
  if (typeof input.page === 'number' && input.page > 0) {
    result.page = input.page;
  } else if (typeof input.page === 'string') {
    const n = Number.parseInt(input.page, 10);
    if (Number.isFinite(n) && n > 0) result.page = n;
  }
  return result;
};
